import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "renderChildrenAsHTML", "children", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Polymorphic component for rendering rich text.
 *
 * @defaultValue `React.Fragment`
 */
export var RichText = function RichText(_ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'span' : _ref$as,
      _ref$renderChildrenAs = _ref.renderChildrenAsHTML,
      renderChildrenAsHTML = _ref$renderChildrenAs === void 0 ? true : _ref$renderChildrenAs,
      children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  if (renderChildrenAsHTML && typeof children === 'string') {
    /**
     * Only allow strings to be rendered as HTML
     *
     * TODO: [WCDS] Replace with a more fully featured solution
     *  like Contentful's Rich Text Renderer
     */
    return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, rest), {}, {
      className: className,
      dangerouslySetInnerHTML: {
        __html: children
      }
    }));
  }

  return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, rest), {}, {
    className: className,
    children: children
  }));
};